<template>
	<div>
		<!-- <div class="text-xs-center email-registration__title">Register</div> -->
		<p class="auth-modal__error">{{error}}</p>
		<v-form v-model="valid" ref="form" lazy-validation>
			<div class="email-registration__form-container">
				<div style="display: flex;">
					<v-text-field class="mr-2" dark label="First Name" v-model="firstName" :rules="nameRules"></v-text-field>
					<v-text-field class="ml-2" dark label="Last Name" v-model="lastName" :rules="nameRules"></v-text-field>
				</div>
				<v-text-field dark validate-on-blur label="Email" v-model="email" :rules="emailRules" id="registrationform-email"></v-text-field>
				<v-text-field dark type="password" label="Password" v-model="password" :rules="passwordRules"></v-text-field>
				<v-text-field dark type="password" label="Verify Password" v-model="passwordVerify" :rules="password2Rules"></v-text-field>
				<p class="text-xs-center mt-4">
					<v-btn flat @click="register" class="email-registration__register-button" :loading="loginEmailRedirecting" id="authBtn-registerbutton"><p>Register</p></v-btn>
					<br>
					<v-btn flat class="email-registration__login-button" @click="setUrlHash('login')"><p>Already have an account?  Login</p></v-btn>
				</p>
			</div>
		</v-form>
	</div>
</template>

<script>
import axios from 'axios'
import { mapActions, mapGetters } from 'vuex'

export default {
	data () {
		return {
			valid: true,
			firstName: '',
			lastName: '',
			nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 10) || 'Name must be less than 10 characters'
      ],
			email: '',
			emailRules: [
				v => !!v || 'E-mail is required',
				v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
			],
			password: '',
			passwordVerify: '',
			passwordRules: [
				v => !!v || 'Password is required',
			],
			password2Rules: [
				v => !!v || 'Password verification is required',
				v => v === this.password || 'Password and verification do not match',
			],
			loginEmailRedirecting: false,
			error: null
		}
	},
	methods: {
		...mapActions([
			'setAuthModalOpen',
			'setAuthRedirect',
			'setToken',
			'setUserSocial'
		]),
		setUrlHash(hash) {
			window.location.hash = hash
		},
		register() {
			if (this.$refs.form.validate()) {
				axios
					.post('/rest-auth/registration/', {
						username: this.email,
						email: this.email,
						password1: this.password,
						password2: this.passwordVerify
					})
					.then((response) => {
						this.setToken(response.data.token)
						axios.defaults.headers.common['Authorization'] = 'Bearer ' + response.data.token
						this.setUserSocial(response.data.user)
						axios
							.put('/rest-auth/user/', {
								username: response.data.user.username,
								first_name: this.firstName,
								last_name: this.lastName
							})
							.then((response2) => {
								this.setAuthModalOpen(false)
								if (response2.data.active === false) {
									// window.location = '/'
									this.$router.replace('/')
								} else {
									if (this.getAuthRedirect) {
										this.setAuthRedirect(null)
										window.location = this.getAuthRedirect
									} else {
										// window.location = '/'
										this.$router.replace('/')
									}
								}
								this.loginEmailRedirecting = false
							})
							.catch((error) => {
								console.error(error)
							})
					})
					.catch(error => {
						this.loginEmailRedirecting = false
						this.errors = error.response.data
						console.error(error)
						console.error(error.response)
						if (error.response.data) {
							if (error.response.data.password1) {
								if (error.response.data.password1.length > 0) {
									this.error = error.response.data.password1[0]
								}
							}
						}
					})
			}
		}
	}
}
</script>

<style lang="scss">
.auth-modal__error {
	color: red;
	font-size: 0.9em;
}
.email-registration__form-container {
	padding: 0 10px;
}
.email-registration__register-button {
	color: white!important;
	border: 1px solid white;
	border-radius: 0;
	width: 150px;
	height: 50px;
	p {
		color: white!important;
		font-family: 'Nunito', sans-serif;
		font-weight: 200;
		font-size: 1.1em;
		margin: 0;
	}
	margin-bottom: 15px;
}
.email-registration__login-button {
	color: white!important;
	p {
		color: #FFF!important;
		font-family: 'Nunito', sans-serif;
		font-weight: 200;
		margin: 0;
	}
}

.email-registration__title {
	color: #EEE!important;
	font-family: 'Nunito', sans-serif;
	font-weight: 200;
	font-size: 2.0em;
	margin-bottom: 30px;
}
</style>
